function createSlick() {
  $(".collection-slider").each(function (index, slider) {
    var id = index + 1;
    var slideShow = $(this).attr("data-slideshow");
    var slide = parseInt(slideShow)
    $(slider)
      .not(".slick-initialized")
      .slick({
        infinite: false,
        slidesToShow: slide,
        slidesToScroll: 1,
        lazyLoad: 'ondemand',
        dots: true,
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              arrows: false,
            },
          },
          {
            breakpoint: 750,
            settings: {
              arrows: false,
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
  });
}
$(document).ready(function () {
  createSlick();
  StampedFn.reloadUGC();
});

//Now it will not throw error, even if called multiple times.
$(window).on("resize", createSlick);

$(".collection-style .collection-slider, .blog-style .collection-slider").each(function (index, slider) {
  var id = index + 1;
  var slideShow = $(this).attr("data-slideshow");
  $(slider)
    .not(".slick-initialized")
    .slick({
      infinite: true,
      slidesToShow: slideShow,
      slidesToScroll: 1,
      lazyLoad: 'ondemand',
      dots: true,
      responsive: [
        {
          breakpoint: 1300,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
          },
        },
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
});
